/**
 * LoggedIn form component.
 *
 * @returns {JSX.Element}
 */
// State action for update/set rule config.
import {useDispatch} from 'react-redux';
import {setRuleConfig} from "@app/modules/PersonaForm/store/PersonaFormStore";
import {useEffect} from "react";

export default function Windows() {

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(setRuleConfig(
			{
				id: 'Windows',
				config: {
					ruleType: "os",
					args: {
						os: ["windows"]
					}
				}
			}
		));
	}, []);

	return <>
		<p>
			This
			rule
			targets
			Windows
			operating
			systems.
		</p>
	</>;
}
